export default __webpack_public_path__ + "static/media/SignIn.4a9b963b.webp";